import { render, staticRenderFns } from "./RedirectToV1.vue?vue&type=template&id=2280493e&scoped=true"
import script from "./RedirectToV1.vue?vue&type=script&lang=js"
export * from "./RedirectToV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280493e",
  null
  
)

export default component.exports